import React, { useContext, useEffect, useRef, useState } from 'react';
import { ApiContext } from '@api/api';
import { LovDTO } from '@api/ringil-api.v2';
import { MultiSelect } from 'primereact/multiselect';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  companyId: string;
  permission: string;
  value: string[];
  onChange: (selectedIds: string[]) => void;
  style?: any;
  disabled?: boolean;
  dataTestId?: string;
}

export const InputCounterPartyNotifyPersonsIds: React.FC<ComponentProps> = ({ companyId, permission, value, onChange, style, disabled = false, dataTestId }) => {
  const { lovUsersOfCompanyWithSpecificPermission } = useContext(ApiContext);
  const [users, setUsers] = useState<LovDTO[]>([]);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!companyId) {
      setUsers([]);
      return;
    }
    lovUsersOfCompanyWithSpecificPermission(companyId, permission, '', d => setUsers(d));
  }, [companyId, permission]);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-multiselect', dataTestId);
  }, [dataTestId, users]);

  return (
    <div ref={wrapperRef}>
      <MultiSelect
        value={value}
        options={users}
        onChange={e => onChange(e.target.value)}
        optionLabel="name"
        optionValue={'id'}
        style={{ width: '100%', ...(style ?? {}) }}
        disabled={disabled || !companyId}
        filter={true}
        itemTemplate={(option: LovDTO) => (
          <>
            {option.active ? (
              <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || '')}` : undefined}>{option.name}</span>
            ) : (
              <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || '')}` : undefined} style={{ textDecoration: 'line-through', color: 'gray' }}>
                {option.name}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
};
